module.exports = __webpack_public_path__ + "img/logo.e663f1f5.png";